import  { useGetSessionQuery } from '../api/apiSlice';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { getCookie } from '../auth/handleCookie';
import { getHostname } from '../utils/getHostname';
import { jwtDecode } from 'jwt-decode';
import { Suspense } from 'react';

const UserRoute = () => {
    const { data: session, isLoading } = useGetSessionQuery();
    const email_verified = session?.claims?.['email_verified']
    return true // email_verified
        ? <Suspense><Outlet /></Suspense>
        : <Navigate to="/" replace />;
};

export default UserRoute;